import React, { useState, useEffect } from 'react'
import { Link ,useLocation } from 'react-router-dom'

const Main = () => {

    const [mobile, setmobile] = useState(false)

    const location = useLocation()
    const path = location.pathname

    useEffect(() => {
        window.scroll(0, 0)
    }, [path]);

    return (
        <>
            <header className="header-area header-three">
                <div id="header-sticky" className="menu-area">
                    <div className="container">
                        <div className="second-menu">
                            <div className="row align-items-center">
                                <div className="col-xl-2 col-lg-2">
                                    <div className="logo">
                                        <Link to="/"><img src="assets/img/logo/logoHLF.png" alt="logo" style={{ width: '120px', height: 'auto' }} /></Link>
                                    </div>
                                </div>
                                <div className="col-xl-8 col-lg-8">
                                    <div className="main-menu text-center">
                                        <nav id="mobile-menu ">
                                            <ul>
                                            {/* <li><Link to="/">Home</Link></li> */}
                                            <li className="has-sub">
                                            <Link to="/about">Nosotros</Link>
                                            </li>
                                                <li className="has-sub">
                                                    <Link to="/room-details-cama-king">Habitaciones</Link>
                                                    <ul>
                                                        <li> <Link to="/room-details-cama-king">Cama King</Link></li>
                                                        <li> <Link to="/room-details-camas-dobles">Camas Dobles</Link></li>
                                                    </ul>
                                                </li>
                                                <li className="has-sub">
                                                    <Link to="/service-details">Servicios</Link>
                                                    {/* <ul>
                                                        <li> <Link to="/service">Services</Link></li>
                                                        <li> <Link to="/service-details">Services Details</Link></li>
                                                    </ul> */}
                                                </li>
                                                <li className="has-sub"><Link to="/contact">Contacto</Link></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                                <div className="col-xl-2 col-lg-2 d-none d-lg-block">
                                    {/* <Link to="Reservation" className="top-btn mt-10 mb-10">Reserva </Link> */}
                                    <a
                                        href="https://us2.cloudbeds.com/en/reservation/2C4nnm?currency=mxn"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="top-btn mt-10 mb-10"
                                    >
                                        Reserva
                                    </a>
                                </div>
                                <div className="col-12">
                                    <div className="mobile-menu mean-container">
                                        <div className="mean-bar"><Link to="#nav" className={`meanmenu-reveal ${mobile && "meanclose"}`} onClick = {() => setmobile(mobile === true ? false : true)} style={{ right: "0px" , left: "auto", textAlign: "center", textIndent: "0px", fontSize: "18px"}}>
                                            {mobile ?
                                            "X"
                                            :
                                            <>
                                                <span><span><span></span></span></span>
                                                </>
                                            }
                                        </Link>
                                            <nav className="mean-nav">
                                                {mobile && 
                                                <ul style={{ display: mobile ? "block" : "none" }}>
                                                    <li className="has-sub">
                                                        <Link to="/about" onClick={() => setmobile(false)}>Nosotros</Link>
                                                    </li>
                                                    <li className="has-sub">
                                                        <Link to="/room-details-cama-king" onClick={() => setmobile(false)}>Habitaciones</Link>
                                                        <ul>
                                                            <li> <Link to="/room-details-cama-king" onClick={() => setmobile(false)}>Cama King</Link></li>
                                                            <li> <Link to="/room-details-camas-dobles" onClick={() => setmobile(false)}>Camas Dobles</Link></li>
                                                        </ul>
                                                    </li>
                                                    <li className="has-sub">
                                                        <Link to="/service-details" onClick={() => setmobile(false)}>Servicios</Link>
                                                    </li>
                                                    <li className="has-sub">
                                                        <Link to="/contact" onClick={() => setmobile(false)}>Contacto</Link>
                                                    </li>
                                                    {/* <li>
                                                        <Link to="/Reservation" onClick={() => setmobile(false)} className="top-btn">Reserva</Link>
                                                    </li> */}
                                                    <li>
                                                    <a
                                                        href="https://us2.cloudbeds.com/en/reservation/2C4nnm?currency=mxn"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        onClick={() => setmobile(false)}
                                                        className="top-btn"
                                                    >
                                                        Reserva
                                                    </a>
                                                    </li>
                                                </ul>
                                                }
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default Main